import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import classes from "./UniCellButtons.styl";

export interface IButtons extends PropsWithChildren {}

const UniCellButtons: FC<IButtons> = ({ children }): JSX.Element => {
    return (
        <div className={classes.buttons} data-tsid="unicell-buttons-test-id">
            {children}
        </div>
    );
};

UniCellButtons.displayName = "UniCell.Buttons";

export default UniCellButtons;
